import React from "react";
import { Box } from "@mui/material";
import { QTO_SOURCES } from "../../../../integrations/qto/registry";
import { TakeOffSourceType } from "../../../context/DatasourceContext";

type LogoVariant = "card" | "drawer";

const VARIANT_SIZE: Record<LogoVariant, { height: string; maxWidth?: string }> = {
  drawer: { height: "29px", maxWidth: "183px" },
  card: { height: "20px", maxWidth: "144px" },
};

interface TakeOffSourceLogoProps {
  type: TakeOffSourceType;
  variant?: LogoVariant;
}

/**
 * Width is never set — the three logos range from 4.7:1 to 9.7:1, so fixing both dimensions
 * letterboxes all but one of them. Spacing is the caller's, not the logo's.
 */
const TakeOffSourceLogo: React.FC<TakeOffSourceLogoProps> = ({ type, variant = "card" }) => {
  const { label, logo } = QTO_SOURCES[type];
  if (!logo) return null;

  const { height, maxWidth } = VARIANT_SIZE[variant];

  return (
    <Box
      component="img"
      src={logo}
      alt={`${label} Logo`}
      sx={{
        height,
        maxWidth,
        display: "block",
      }}
    />
  );
};

export default TakeOffSourceLogo;
